import {retainWan} from "@/plugins/helper";

export const makeOptions = (data = {}) => {
  return {
    color: ['#FFBA32','#2a89f4'],
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(255,255,255,0.7)',
      formatter(config) {
        const name = config?.name ? config?.name : '未知'
        const value = retainWan(config?.data?.realValue,false,2,'--')
        return `<div >
                <div>${name}</div>
                <div>${value}</div>
              </div>`;
      },
      borderWidth:0
    },
    series: {
      radius: ['40%', '70%'],
      center: ['50%', '50%'],
      type: 'pie',
      data: [
        {
          realValue: data?.new?.commodityCount,
          value: data?.new?.commodityCount,
          name:'新品数量',
          label:{ show: false }
        },
        {
          emphasis: {
            disabled:true,
          },
          name:'总商品数量',
          realValue: data?.total?.commodityCount,
          value: data?.total?.commodityCount - data?.new?.commodityCount,
          label:{ show: false }
        },
      ],
      label:{
        distanceToLabelLine: 1,
      },
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  }
}
